var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4"},[_c('iframe',{attrs:{"src":_vm.srcIframe,"frameborder":"0","height":"425px","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }